
//-----------------StyleSheet--------------------
export { default as ButtonStyle } from '@/styles/components/button/_index.module.scss';
export { default as PageStyle } from '@/styles/pages/clients/automation/_index.module.scss';
export { default as UploadStyle } from '@/styles/components/tech-test/_index.module.scss';
//-----------------StyleSheet--------------------

//------------------Images ---------------------
export { default as Call } from 'public/icons/call2.svg';
export { default as Video } from 'public/icons/video.svg';
export { default as User } from 'public/icons/user.svg';
export { default as Robot } from 'public/icons/robot.svg';
export { default as Tech } from 'public/icons/technical.svg';
export { default as VideoQA } from 'public/icons/videoqa.svg';
export { default as UploadIcon } from 'public/icons/uploadIcon.svg';

//------------------Images ---------------------


//------------------- Custom Components --------------
export { default as SetupPopup } from "@/components/setupmodel";
//------------------- Custom Components --------------

export {InputError} from '@/actions/common/input-error';

export {SendRequest} from '@/services/common/send-request';

export { API, AutocompleteError, axios, Button, Checkbox, clearSWRCache, DataFromUrl, Field, FieldArray, Form, Formik, FormikControl, handleOtherResponseCode, goToNextPage, Image, 
         INTERVIEW_TYPES, JOB_STAGES, JOB_STEPS, Link, motion, NextServerCookies, PAGE_ANIMATION_OPTIONS, REDIRECT, RESOURCE_NOT_FOUND_REPONSE_CODE, React, Sidebar, Select,
         SUCCESS_REPONSE_CODE, toastr, TRANSLATION, UNPROCESSABLE_ENTITY_RESPONSE_CODE, useEffect, useQueryClient, useRouter, useState, 
         useSWR, useTranslation, Yup, CustomToastrAction, CommonAction, Tooltip, INTERVIEW_TYPE_HEADERS, useRef, ErrorPages, InputText} from '@/imports-files/common/common';

export {Automation} from '@/services/pages/clients/jobs/automation';

export { automationText,  getAutomationData, getBgClass, getJobStageData, getManualJobStageData, handleKeyDown, handleInterviewFormSubmit, handleDelete, mangeInterviews, initialStageValues, interviewStageName, interviewTypeIcon,  onSuggestionSelection, onAutomationChange, onSuggestionsFetchRequested, renderSuggestion, updateThreshold, getTechTestData, getAssessmentTestData,
         handleAutomationFormSubmit, renderLabel,  renderInputComponent, renderAutomationModalInputComponent, showSuggestion, shouldRenderSuggestions,  testDuration, manageModals, showHideButtonValue, interviewTypeHeader, handleVideoQAFormSubmit, setUpTechTest, defaultTestDetail, userHash, setUpVideoQAMember, isLocationDisabled, addInitalInterview, setFormDirty} from '@/actions/pages/clients/jobs/automation'

export {draftJob, previewJob, startDateMessage, hideDraft, cursorNone, toggleDisabled, jobStatusBadge} from '@/actions/pages/clients/jobs/common';

export {getClientUsers} from '@/actions/pages/clients/jobs/interview_stages'

export {TechTestAction} from '@/actions/pages/clients/jobs/tech-test';
export {VideoQaAction} from '@/actions/pages/clients/jobs/video-qa-action';
export {default as AutomationModal} from '@/pages/clients/dashboard/jobs/automation-modal';
export {default as  MyInterviewWidget } from '@/pages/clients/dashboard/recruitments/my-interview-widget';

export {INITIAL_VALUES, duration, validations} from '@/constants/pages/clients/jobs/automation';

export {default as BacktoAllJobs} from '@/pages/clients/jobs/back-all-jobs-modal';

// export { default as JobPreviewPage} from '@/pages/clients/dashboard/jobs/job-preview'


export {runAutomations} from '@/actions/pages/clients/candidates/kanban';

export { URL_FORMAT, MANAGE_ASSESSMENT } from '@/constants/pages/clients/recruitment/manage-assessment'